<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <vendor-list
        v-bind:vendors="vendorList"
        v-on:addVendor="addVendor"
        v-on:viewVendor="viewVendor"
        v-on:deleteVendor="deleteVendor"
      ></vendor-list>
    </div>
    <div class="md-layout-item md-size-50">
      <vendor-tabs
        :vendor="selectedVendor"
        v-on:vendorUpdated="vendorUpdated"
      ></vendor-tabs>
    </div>
  </div>
</template>

<script>
import venderApi from "@/services/api/vendor";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import Swal from "sweetalert2";

import VendorList from "./VendorList";
import VendorTabs from "./VendorTabs";

export default {
  components: {
    VendorList,
    VendorTabs
  },

  data() {
    return {
      selectedVendor: null,
      vendorList: []
    };
  },

  methods: {
    getVendors() {
      venderApi.getVendors().then(response => {
        this.vendorList = response.data;
      });
    },

    addVendor() {
      this.selectedVendor = {};
    },

    viewVendor(vendor) {
      this.selectedVendor = { ...vendor };
    },

    deleteVendor(vendor) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          venderApi.deleteVendor(vendor.id).then(response => {
            this.vendorList = _filter(this.vendorList, function(r) {
              return r.id !== vendor.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    vendorUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.vendorList.unshift(updateInfo.vendor);
      } else {
        var index = _findIndex(this.vendorList, {
          id: updateInfo.vendor.id
        });
        this.vendorList.splice(index, 1, updateInfo.vendor);
      }

      this.selectedVendor = updateInfo.vendor;
    }
  },

  mounted() {
    this.getVendors();
  }
};
</script>
